import Moment from "moment";
var momentTz = require("moment-timezone");

export const TIME_FORMAT = "HH:mm A";

export const createISOTimeString = (timeString) => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const isoStr = momentTz
    .tz(
      timeString, //"2021-01-27 14:02:45",
      "YYYY/MM/DD HH:mm A", //"DD-MM-YYYY HH:mm";
      timezone
    )
    .toISOString();
  return isoStr;
};

export const createTZString = (timeString) => {
  const timezone = Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone;
  return momentTz(timeString)?.tz(timezone);
};

const getAbbreviationValue = (timeZoneId) => {
  const date = new Date();
  const options = { timeZone: timeZoneId, timeZoneName: 'short' };
  const formatter = new Intl.DateTimeFormat('en-US', options);
  const parts = formatter.formatToParts(date);
  const abbreviationPart = parts.find(part => part.type === 'timeZoneName');
  return abbreviationPart?.value;
}

export const getTimezoneFromLatLong = async (booking, timezoneId) => {
  return new Promise((resolve, reject) => {
    const latitude = booking?.location?.latitude;
    const longitude = booking?.location?.longitude;

    if (booking?.timezone?.timeZoneId) {
      if (timezoneId) {
        resolve(booking?.timezone?.timeZoneId);
        return;
      }
      const abbreviationValue = getAbbreviationValue(booking?.timezone?.timeZoneId);
      resolve(abbreviationValue);
      return;
    }

    if (latitude && longitude) {
      const apiKey = window?.env?.REACT_APP_GOOGLE_API_KEY;
      const apiUrl = `https://maps.googleapis.com/maps/api/timezone/json?location=${latitude},${longitude}&timestamp=1331161200&key=${apiKey}`;

      fetch(apiUrl)
        .then(response => response.json())
        .then(data => {
          if (data?.status === 'OK') {
            booking?.set && booking.set("timezone", { timeZoneId: data?.timeZoneId, timeZoneName: data?.timeZoneName });
            if (timezoneId) {
              resolve(data?.timeZoneId);
              return;
            }
            const abbreviationValue = getAbbreviationValue(data?.timeZoneId);
            resolve(abbreviationValue);
          } else {
            reject("");
          }
        })
        .catch(() => {
          reject("")
        });
    }
  });
};

export const createDateTimeFormat = (timeString) => {
  let startDateTime = createTZString(timeString);

  return Moment(startDateTime._d).format("YYYY-MM-DD HH:mm");
};

export const createDateFormat = (timeString) => {
  let startDateTime = createTZString(timeString);

  return Moment(startDateTime._d).format("YYYY-MM-DD");
};

export const compareIfDateIsSameOrGreater = (date1, date2) => {
  return Moment(date2).isSameOrAfter(date1);
};
